import type { ChainId } from "./types";

export type ChainFamily = "solana" | "evm";

export interface ChainInfo {
  id: ChainId;
  family: ChainFamily;
  /** What the customer sees: "Solana", "Base". */
  name: string;
  /** Network name as exchanges label it in their withdraw form. */
  exchangeNetwork: string;
  testnet: boolean;
  /** Suffix shown on test networks: "Devnet", "Sepolia". */
  testnetLabel: string | null;
  evmChainId: number | null;
}

export const CHAINS: Record<ChainId, ChainInfo> = {
  "solana-mainnet": {
    id: "solana-mainnet",
    family: "solana",
    name: "Solana",
    exchangeNetwork: "Solana (SOL / SPL)",
    testnet: false,
    testnetLabel: null,
    evmChainId: null,
  },
  "solana-devnet": {
    id: "solana-devnet",
    family: "solana",
    name: "Solana",
    exchangeNetwork: "Solana (SOL / SPL)",
    testnet: true,
    testnetLabel: "Devnet",
    evmChainId: null,
  },
  "base-mainnet": {
    id: "base-mainnet",
    family: "evm",
    name: "Base",
    exchangeNetwork: "Base",
    testnet: false,
    testnetLabel: null,
    evmChainId: 8453,
  },
  "base-sepolia": {
    id: "base-sepolia",
    family: "evm",
    name: "Base",
    exchangeNetwork: "Base",
    testnet: true,
    testnetLabel: "Sepolia",
    evmChainId: 84532,
  },
};

export function chainInfo(id: ChainId): ChainInfo {
  return CHAINS[id];
}

/** "Solana Devnet", "Base". */
export function chainLabel(id: ChainId): string {
  const info = CHAINS[id];
  return info.testnetLabel ? `${info.name} ${info.testnetLabel}` : info.name;
}

export function explorerTxUrl(chain: ChainId, hash: string): string {
  switch (chain) {
    case "solana-mainnet":
      return `https://explorer.solana.com/tx/${hash}`;
    case "solana-devnet":
      return `https://explorer.solana.com/tx/${hash}?cluster=devnet`;
    case "base-mainnet":
      return `https://basescan.org/tx/${hash}`;
    case "base-sepolia":
      return `https://sepolia.basescan.org/tx/${hash}`;
  }
}

export function explorerAddressUrl(chain: ChainId, address: string): string {
  switch (chain) {
    case "solana-mainnet":
      return `https://explorer.solana.com/address/${address}`;
    case "solana-devnet":
      return `https://explorer.solana.com/address/${address}?cluster=devnet`;
    case "base-mainnet":
      return `https://basescan.org/address/${address}`;
    case "base-sepolia":
      return `https://sepolia.basescan.org/address/${address}`;
  }
}
